import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { Events } from '@carvana/vdp-events';
import {
  useIsLoggedIn,
  useUserLocation,
  useUserId
} from '~/context/common/UserContext';
import { generateCustomEventDetail } from '~/utilities/vdp/browserEvents';

const getEventEl = () => document.querySelector<HTMLElement>('#vdp-events');

export default function useEventDispatchers() {
  const isLoggedIn = useIsLoggedIn();
  const { zip } = useUserLocation();
  const userId = useUserId();

  // Geolocation
  useSubsequentEffect(() => {
    getEventEl()?.dispatchEvent(
      new CustomEvent(Events.Geolocation, {
        detail: generateCustomEventDetail()
      })
    );
  }, [zip]);

  // User Profile
  useSubsequentEffect(() => {
    getEventEl()?.dispatchEvent(
      new CustomEvent(Events.UserProfile, {
        detail: generateCustomEventDetail()
      })
    );
  }, [isLoggedIn, userId]);
}
